module.exports = __webpack_public_path__ + "static/media/stop.a0be757d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stop.svg
// module id = 45
// module chunks = 0